<template>
  <div class="yidi">
    <div class="ipbox">
      <titleCard title="异地透析"></titleCard>
      <div class="title-text">为全国透析患者提供异地透析、专家诊疗及咨询、对接医院、预约床位、陪诊、接送等全程服务，满足血透患者出门旅游、探亲、出差、看病等需求，解决一切“后顾之忧”。</div>
      <div class="PCbox">
        <div class="brief-box">
          <div class="box-img animate__animated wow animate__fadeInLeft">
            <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/D42E9B898EC44B8187A653197BCA40DB-6-2.png">
          </div>
          <div class="box-txt animate__animated wow animate__fadeInRight">
            <h2>01</h2>
            <h3>严格筛选合作医疗机构</h3>
            <p>全国范围内为患者匹配的血透中心都严格的经过公司专员<br>进行实地查看和严格筛查，满足血透患者异地透析需要。</p>
          </div>
        </div>
        <div class="brief-box">
          <div class="box-txt boxstyle animate__animated wow animate__fadeInLeft">
            <h2>02</h2>
            <h3>预约、陪诊全程专业服务</h3>
            <p>提供专业人员为血透患者异地透析选择医院、预约床位、陪<br>同就医、专车接送、治疗陪护及后续疾病跟踪咨询等一站式<br>服务，帮助每一位患者做好服务的“贴心人”。</p>
          </div>
          <div class="box-img animate__animated wow animate__fadeInRight">
            <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/1E5A521021D747D6A1F4D9FE543E5D69-6-2.png">
          </div>
        </div>
        <div class="brief-box">
          <div class="box-img animate__animated wow animate__fadeInLeft">
            <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/61C4BDDD0BCD4ADF87A3F579B03625D8-6-2.png">
          </div>
          <div class="box-txt animate__animated wow animate__fadeInRight">
            <h2>03</h2>
            <h3>专业医疗服务网络平台</h3>
            <p>线上+线下融合模式，实现患者和机构、资源之间的精准对<br>接，为肾病患者提供从慢性病全流程随访管理服务到对接线<br>下透析的全病程医疗服务。</p>
          </div>
        </div>
        <div class="brief-box">
          <div class="box-txt boxstyle animate__animated wow animate__fadeInLeft">
            <h2>04</h2>
            <h3>医联体双向转诊绿色通道</h3>
            <p>与合作医疗机构所在当地三甲医院建立长期的“绿色通道”<br>转诊机制，满足异地透析患者多层次的医疗需求，凡遇复<br>杂的血管通路、透析严重并发症可直接“无障碍转诊”。</p>
          </div>
          <div class="box-img animate__animated wow animate__fadeInRight">
            <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/9D0A4E5B1CA441B0AA51BEE08AB1EE6B-6-2.png">
          </div>
        </div>
      </div>
      <div class="Iosbox">
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/D42E9B898EC44B8187A653197BCA40DB-6-2.png">
          </div>
          <div class="txt">
            <div class="left">
              <h2>01</h2>
            </div>
            <div class="right">
              <h3>严格筛选合作医疗机构</h3>
              <p>全国范围内为患者匹配的血透中心都严格的经过公司专员进行实地查看和严格筛查，满足血透患者异地透析需要。</p>
            </div>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/1E5A521021D747D6A1F4D9FE543E5D69-6-2.png">
          </div>
          <div class="txt">
            <div class="left">
              <h2>02</h2>
            </div>
            <div class="right">
              <h3>预约、陪诊全程专业服务</h3>
              <p>提供专业人员为血透患者异地透析选择医院、预约床位、陪同就医、专车接送、治疗陪护及后续疾病跟踪咨询等一站式服务，帮助每一位患者做好服务的“贴心人”。</p>
            </div>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/61C4BDDD0BCD4ADF87A3F579B03625D8-6-2.png">
          </div>
          <div class="txt">
            <div class="left">
              <h2>03</h2>
            </div>
            <div class="right">
              <h3>专业医疗服务网络平台</h3>
              <p>线上+线下融合模式，实现患者和机构、资源之间的精准对接，为肾病患者提供从慢性病全流程随访管理服务到对接线下透析的全病程医疗服务。</p>
            </div>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/9D0A4E5B1CA441B0AA51BEE08AB1EE6B-6-2.png">
          </div>
          <div class="txt">
            <div class="left">
              <h2>04</h2>
            </div>
            <div class="right">
              <h3>医联体双向转诊绿色通道</h3>
              <p>与合作医疗机构所在当地三甲医院建立长期的“绿色通道”转诊机制，满足异地透析患者多层次的医疗需求，凡遇复杂的血管通路、透析严重并发症可直接“无障碍转诊”。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footerCard name="李老师" phone="138-1097-5144"></footerCard>
  </div>
</template>

<script>
import footerCard from '../../components/footer-card.vue'
import titleCard from '../../components/title-card.vue'
export default {
  data() {
    return {

    }
  },
  components: {
    footerCard,
    titleCard
  },
  created() {

  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.yidi {
  .ipbox {
    padding: 1.3684rem 0 1.5789rem 0;
    .title-text {
      color: #272b2d;
      font-size: 0.2526rem;
      text-align: center;
      padding: 0.5263rem 0 0;
      width: 55%;
      line-height: 0.5263rem;
      margin: 0 auto;
      @media screen and (max-width: 540px) {
        padding: 33px 0 20px 0;
        font-size: 13px;
        line-height: 25px;
        width: 90%;
      }
    }
    .PCbox {
      @media screen and (max-width: 540px) {
        display: none;
      }
      .brief-box {
        padding-top: 1.0526rem;
        display: flex;
        height: 5.8421rem;
        .box-img {
          width: 50%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .boxstyle {
          padding-left: 2.3158rem !important;
        }
        .box-txt {
          width: 50%;
          box-sizing: border-box;
          padding-left: 1.5789rem;
          h2 {
            padding-top: 1rem;
            margin: 0;
            color: #0ca6eb;
            font-size: 0.8421rem;
            font-weight: 700;
            position: relative;
          }
          h2::after {
            position: absolute;
            left: 0;
            bottom: 0;
            content: '';
            width: 0.2105rem;
            height: 0.0526rem;
            background-color: #0ca6eb;
          }
          h3 {
            margin: 0;
            padding: 0.3895rem 0 0.5053rem 0;
            color: #000000;
            font-size: 0.4211rem;
          }
          p {
            color: #333333;
            line-height: 0.4211rem;
            font-size: 0.2526rem;
          }
        }
      }
    }
    .Iosbox {
      display: none;
      margin-bottom: 45px;
      @media screen and (max-width: 540px) {
        display: block;
      }
      .box {
        padding: 0 15px;
        padding-top: 48px;
        .pic {
          width: 100%;
          height: 223px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .txt {
          padding-top: 15px;
          display: flex;
          .left {
            padding-right: 11px;
            h2 {
              position: relative;
              color: #0ca6eb;
              font-size: 30px;
              margin: 0;
            }
            h2::after {
              position: absolute;
              left: 9px;
              bottom: -2px;
              content: '';
              width: 18px;
              height: 3px;
              background-color: #0ca6eb;
            }
          }
          .right {
            flex-wrap: wrap;
            h3 {
              color: #000;
              font-size: 16px;
              margin: 0;
              padding-top: 8px;
              margin-bottom: 10px;
            }
            p {
              color: #333;
              font-size: 14px;
              padding-right: 15px;
              line-height: 22px;
            }
          }
        }
      }
    }
  }
}
</style>
